import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Eye, EyeOff, Loader2, ShieldAlert } from "lucide-react";
import { api } from "../lib/api";
import { PublicShell } from "./legal/LegalPage";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [pw1, setPw1] = useState("");
    const [pw2, setPw2] = useState("");
    const [showPw, setShowPw] = useState(false);
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const submit = async () => {
        setError("");
        if (pw1.length < 8) return setError("Şifre en az 8 karakter olmalıdır");
        if (pw1 !== pw2) return setError("Şifreler eşleşmiyor");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password: pw1 });
            setDone(true);
        } catch (e) {
            const d = e.response?.data?.detail;
            setError(typeof d === "string" ? d : "Şifre sıfırlanamadı");
        } finally {
            setBusy(false);
        }
    };

    return (
        <PublicShell title="Şifre Sıfırlama" subtitle="Yeni şifrenizi belirleyin" testId="reset-page">
            <div className="mx-auto mt-8 max-w-md rounded-2xl border bg-card p-6 shadow-sm">
                {!token ? (
                    <div className="text-center" data-testid="reset-error">
                        <ShieldAlert className="mx-auto h-10 w-10 text-destructive" />
                        <p className="mt-3 text-sm">Geçersiz bağlantı — sıfırlama bağlantısı eksik.</p>
                    </div>
                ) : done ? (
                    <div className="text-center" data-testid="reset-success">
                        <CheckCircle2 className="mx-auto h-10 w-10 text-sage-600" />
                        <p className="mt-3 text-sm font-semibold">Şifreniz güncellendi!</p>
                        <p className="mt-1 text-sm text-muted-foreground">Artık e-posta ve şifrenizle giriş yapabilirsiniz.</p>
                        <Link to="/">
                            <Button className="mt-4 bg-terra-600 text-white hover:bg-terra-700" data-testid="reset-goto-login">Giriş Sayfasına Git</Button>
                        </Link>
                    </div>
                ) : (
                    <div className="space-y-3">
                        <div className="relative">
                            <Input
                                type={showPw ? "text" : "password"}
                                placeholder="Yeni şifre (en az 8 karakter)"
                                value={pw1}
                                onChange={(e) => setPw1(e.target.value)}
                                data-testid="reset-password-input"
                            />
                            <button type="button" onClick={() => setShowPw((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
                                {showPw ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                            </button>
                        </div>
                        <Input
                            type={showPw ? "text" : "password"}
                            placeholder="Yeni şifre (tekrar)"
                            value={pw2}
                            onChange={(e) => setPw2(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && submit()}
                            data-testid="reset-password2-input"
                        />
                        {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
                        <Button onClick={submit} disabled={busy} className="w-full bg-terra-600 text-white hover:bg-terra-700" data-testid="reset-submit">
                            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Şifremi Güncelle
                        </Button>
                    </div>
                )}
            </div>
        </PublicShell>
    );
}
